import z from 'zod';

export const boostBalanceResponseSchema = z
    .object({
        boosts: z.number().int().nonnegative(),
    })
    .describe('BoostBalanceResponse');

export type BoostBalanceResponse = z.infer<typeof boostBalanceResponseSchema>;

export const BoostRedemptionKinds = {
    Playtime: 'playtime',
} as const;

export const boostRedemptionKindSchema = z.enum([BoostRedemptionKinds.Playtime]);

export type BoostRedemptionKind = z.infer<typeof boostRedemptionKindSchema>;

export const boostPlaytimeRewardSchema = z
    .object({
        type: z.literal(BoostRedemptionKinds.Playtime),
        durationSeconds: z.number().int().positive(),
    })
    .describe('BoostPlaytimeReward');

export type BoostPlaytimeReward = z.infer<typeof boostPlaytimeRewardSchema>;

export const boostRedemptionRewardSchema = boostPlaytimeRewardSchema.describe('BoostRedemptionReward');

export type BoostRedemptionReward = z.infer<typeof boostRedemptionRewardSchema>;

export const boostRedemptionSchema = z
    .object({
        kind: boostRedemptionKindSchema,
        boostCost: z.number().int().positive(),
        reward: boostRedemptionRewardSchema,
    })
    .describe('BoostRedemption');

export type BoostRedemption = z.infer<typeof boostRedemptionSchema>;

export const boostRedemptionsCatalogSchema = z.array(boostRedemptionSchema).describe('BoostRedemptionsCatalog');

export type BoostRedemptionsCatalog = z.infer<typeof boostRedemptionsCatalogSchema>;

export const boostRedeemRequestSchema = z
    .object({
        kind: boostRedemptionKindSchema,
    })
    .describe('BoostRedeemRequest');

export type BoostRedeemRequest = z.infer<typeof boostRedeemRequestSchema>;

export const boostRedeemResponseSchema = z
    .object({
        kind: boostRedemptionKindSchema,
        boostsSpent: z.number().int().nonnegative(),
        remainingBoosts: z.number().int().nonnegative(),
        reward: boostRedemptionRewardSchema,
        redeemedAt: z.string(),
    })
    .describe('BoostRedeemResponse');

export type BoostRedeemResponse = z.infer<typeof boostRedeemResponseSchema>;

export const boostGrantDebugRequestSchema = z
    .object({
        amount: z.number().int().positive(),
    })
    .describe('BoostGrantDebugRequest');

export type BoostGrantDebugRequest = z.infer<typeof boostGrantDebugRequestSchema>;

export const boostGrantDebugResponseSchema = z
    .object({
        remainingBoosts: z.number().int().nonnegative(),
    })
    .describe('BoostGrantDebugResponse');

export type BoostGrantDebugResponse = z.infer<typeof boostGrantDebugResponseSchema>;

export const BoostQueueFilters = {
    Rising: 'rising',
    Upcoming: 'upcoming',
    User: 'user',
} as const;

export const boostQueueFilterSchema = z.enum([
    BoostQueueFilters.Rising,
    BoostQueueFilters.Upcoming,
    BoostQueueFilters.User,
]);

export type BoostQueueFilter = z.infer<typeof boostQueueFilterSchema>;

export const boostQueueRequestSchema = z
    .object({
        filter: boostQueueFilterSchema,
        page: z.number().int().positive().optional(),
        perPage: z.number().int().positive().optional(),
    })
    .describe('BoostQueueRequest');

export type BoostQueueRequest = z.infer<typeof boostQueueRequestSchema>;

export const boostQueueEntrySchema = z
    .object({
        id: z.number().int(),
        game: z.object({
            id: z.number().int(),
            titleId: z.number().int(),
            titleName: z.string(),
            titleThumbnail: z.string().nullable(),
            platform: z.string(),
        }),
        /** Absent on the upcoming list, which is ordered by release position rather than by boosts. */
        boostCount: z.number().int().optional(),
    })
    .describe('BoostQueueEntry');

export type BoostQueueEntry = z.infer<typeof boostQueueEntrySchema>;

export const boostQueueResponseSchema = z
    .object({
        data: z.array(boostQueueEntrySchema),
    })
    .describe('BoostQueueResponse');

export type BoostQueueResponse = z.infer<typeof boostQueueResponseSchema>;

export const boostReferralsNotifiedRequestSchema = z
    .object({
        ids: z.array(z.number().int()).min(1),
    })
    .describe('BoostReferralsNotifiedRequest');

export type BoostReferralsNotifiedRequest = z.infer<typeof boostReferralsNotifiedRequestSchema>;

export const boostReferralsNotifiedResponseSchema = z.void().describe('BoostReferralsNotifiedResponse');
